import { onCLS, onLCP, onFCP, onTTFB, onINP } from 'web-vitals';

function sendToAnalytics(metric) {
  // Log metrics to console in development
  console.log('[Web Vitals]', metric.name, Math.round(metric.name === 'CLS' ? metric.value * 1000 : metric.value), 'ms');

  // Send to Google Analytics if available
  if (window.gtag) {
    window.gtag('event', metric.name, {
      value: Math.round(metric.name === 'CLS' ? metric.value * 1000 : metric.value),
      event_category: 'Web Vitals',
      event_label: metric.id,
      non_interaction: true,
    });
  }
}

export function initWebVitals() {
  onCLS(sendToAnalytics);
  onLCP(sendToAnalytics);
  onFCP(sendToAnalytics);
  onTTFB(sendToAnalytics);
  onINP(sendToAnalytics); // INP is the modern replacement for FID
}
